import {
  Placeholder,
  PlaceholderLine,
  Segment,
} from '@mairistem/composants';
import React from 'react';

const LiquidationTreeviewLoader = () => (
  <Segment>
    <Placeholder fluid>
      {Array.from({ length: 5 }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <PlaceholderLine key={`loaderLine-${index}`} length="full" />
      ))}
    </Placeholder>
  </Segment>

);

export default LiquidationTreeviewLoader;
